import { render } from "./pageCourse.vue?vue&type=template&id=44609f60&scoped=true"
import script from "./pageCourse.vue?vue&type=script&lang=js"
export * from "./pageCourse.vue?vue&type=script&lang=js"

import "./pageCourse.vue?vue&type=style&index=0&id=44609f60&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44609f60"]])

export default __exports__